import axiosInstance from '@/core/api'
import { GetAdminMeResponse } from '@/modules/admin/type'
import { GetOperatorMeResponse } from '@/modules/operator/type'

export const getProfile = async (): Promise<
	GetOperatorMeResponse & GetAdminMeResponse
> => {
	const role = localStorage.getItem('role')

	const response = await axiosInstance.get<
		GetOperatorMeResponse | GetAdminMeResponse
	>(`/admin/${role?.toLowerCase()}s/me`)

	return { ...response.data } as GetOperatorMeResponse & GetAdminMeResponse
}
